import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomButton, CustomLoadingButton } from "src/design";
import {
  colorTextPrimary,
  colorTextMuted,
  colorActionPrimary,
  colorActionPrimaryHover,
  colorActionPrimaryText,
  radiusButton,
} from "src/design/tokens";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

interface SchedulePageHeaderProps {
  isEditing: boolean;
  updating: boolean;
  hasChanged: boolean;
  canEdit: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onSave: () => void;
}

export const SchedulePageHeader = ({
  isEditing,
  updating,
  hasChanged,
  canEdit,
  onEdit,
  onCancel,
  onSave,
}: SchedulePageHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        mb: 3,
      }}
    >
      <Box>
        <Typography
          variant="h5"
          sx={{ fontWeight: 700, color: colorTextPrimary, mb: 0.5 }}
        >
          {t("schedule.title")}
        </Typography>
        <Typography variant="body2" sx={{ color: colorTextMuted }}>
          {t("schedule.subtitle")}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", gap: 1 }}>
        {isEditing ? (
          <>
            <CustomButton variant="outlined"
              color='inverted'
              size="small"
              onClick={onCancel}
              startIcon={<CloseOutlinedIcon />}
              sx={{ textTransform: "none", borderRadius: radiusButton, fontWeight: 500 }}
            >
              {t("common.cancel")}
            </CustomButton>
            <CustomLoadingButton
              startIcon={<SaveOutlinedIcon />}
              loading={updating}
              onSubmit={onSave}
              label={t("common.saveChanges")}
              disabled={!hasChanged}
              size="small"
              fullwidth={false}
              style={{
                backgroundColor: 'black',
                color: "white"
              }}
            />
          </>
        ) : canEdit ? (
          <Button
            variant="contained"
            size="small"
            onClick={onEdit}
            sx={{
              textTransform: "none",
              borderRadius: radiusButton,
              fontWeight: 600,
              backgroundColor: colorActionPrimary,
              color: colorActionPrimaryText,
              "&:hover": { backgroundColor: colorActionPrimaryHover },
              boxShadow: "none",
            }}
          >
            {t("schedule.editSchedule")}
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};
